
import { defineComponent, computed } from 'vue'
import { ROLE_SLUGS } from '@/utils/roles'
import { isUserRole } from '@/utils/roles'

export default defineComponent({
  setup() {
    // Laboのいずれかの役割を持つかをチェック
    const isLabo = computed(() =>
      isUserRole(['real_trade_lab']) || isUserRole(['trial_trade_lab_202409'])
    )

    const isShindo = computed(() => isUserRole([ROLE_SLUGS.shindo]))

    return {
      isLabo,
      isShindo
    }
  },
})
